import styled from 'styled-components';
import { Box } from '@rsos/base-components';

interface StatusIndicatorProps {
  status: string;
}

export const StatusIndicator = styled(Box).attrs<StatusIndicatorProps>(
  ({ status }) => ({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    bg: status === 'active' ? 'success' : 'transparent',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: status === 'active' ? 'transparent' : 'lightLineDivider',
  }),
)<StatusIndicatorProps>``;

export const AccordionWrapper = styled(Box).attrs({
  bg: 'background',
  width: '100%',
})`
  border-bottom: 1px solid ${p => p.theme.colors.lightLineDivider};
  &:last-child {
    border-bottom: none;
  }
`;

export const AccordionHeader = styled(Box).attrs({
  p: 16,
  cursor: 'pointer',
  justify: 'space-between',
  align: 'center',
  bg: 'background',
  horizontal: true,
})`
  &:hover {
    background: ${p => p.theme.colors.foreground};
  }
`;

export const AccordionContentContainer = styled(Box).attrs<{
  maxHeight: string;
  isOpen: boolean;
}>(() => ({
  overflow: 'hidden',
  transition: 'max-height 0.3s ease-in-out',
}))<{ maxHeight: string; isOpen: boolean }>`
  max-height: ${p => p.maxHeight};
  border-top: ${p =>
    p.isOpen ? `1px solid ${p.theme.colors.heavyLineOutline}` : 'none'};
`;

export const AccordionIcon = styled(Box).attrs({
  align: 'center',
  justify: 'center',
  p: 12,
  color: 'primaryText',
})<{ isOpen: boolean }>`
  transform: ${p => (p.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.3s ease-in-out;
`;
